module.exports = __webpack_public_path__ + "img/ps-20.d625014d.jpg";